<template>
  <div class="report_builder">
    <v-container>
      <h2 class="mb-2">{{ $store.state.customerName }} メニュー作成画面</h2>
      <p>左の部品からドラッグして作成してください。</p>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <!--{{ productForms.area }}-->
      <v-row>
        <v-col cols="12" sm="3">
          <h3 class="mb-2">Form Parts</h3>
          <draggable
            v-model="sampleForms"
            :group="{ name: 'forms', pull: 'clone', put: false }"
            :sort="false"
            :clone="cloneForm"
          >
            <v-card v-for="(form, i) in sampleForms" :key="i" class="mb-4">
              <v-card-title>{{ form.name }}</v-card-title>
            </v-card>
          </draggable>
        </v-col>
        <v-col cols="12" sm="9">
          <v-card outlined class="pa-6">
            <h3 class="mb-2">Form Area 1</h3>
            <draggable
              class="droparea"
              v-model="productForms.area"
              :group="{ name: 'forms', pull: true }"
              :options="{ animation: 100 }"
            >
              <!-- v-forでv-btnとv-iconを連続表示  -->
              <div
                class="d-flex align-center tmp"
                v-for="(form, i) in productForms.area"
                :key="i"
              >
                <v-btn @click="modalOpen(form)" block outlined
                  >{{ form.text }}:{{ form.to }}</v-btn
                >
                <v-icon @click="removeForm(form, i)" color="grey"
                  >fas fa-times</v-icon
                >
                <!-------------------------------------------------->
                <v-dialog v-if="form.menu_dialog" v-model="form.menu_dialog">
                  <menu-form
                    v-on:clickSubmit="modalClose"
                    :type="form.type"
                    :position="i"
                    :text="form.text"
                    :to="form.to"
                    :routes="routes"
                    :color="form.color"
                    :role="form.role"
                  ></menu-form>
                </v-dialog>
              </div>
            </draggable>
            <!------------------------------------->
          </v-card>
          <v-row justify="center" class="mt-4">
            <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import menuForm from "../../components/BuilderForm/MenuForm";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    draggable,
    menuForm,
  },
  data() {
    return {
      sampleForms: [
        {
          type: 4,
          name: "ページリンク",
          //
          text: "帳票一覧",
          to: "/report/index",
          menu_dialog: false,
          role: "0,noRule",
          color: "primary",
        },
      ],
      productForms: {
        pageID: 0,
        area: [],
        delete_area: [],
      },
      routes: [],
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {
        pageID: Number(this.$route.params.page_id),
        area: [[this.productForms.area]],
        delete_area: this.productForms.delete_area,
        customerID: this.$store.state.customerID,
      };
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);

      const response = await api.GetForm(data);
      //ルーティング情報の格納
      this.routes = await api.getRouter();

      if (response.data[0][0].Type != 0) {
        //値の格納
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //読み込み終了
      this.isLoading = false;
    },
    cloneForm: function(obj) {
      //ここが登録される変数
      return {
        //共通
        type: obj.type,
        //メニュー
        text: obj.text,
        to: obj.to,
        menu_dialog: obj.text_dialog,
        role: obj.role,
        color: obj.color,
      };
    },
    removeForm: function(form, i) {
      this.productForms.delete_area.push(form);
      this.productForms.area.splice(i, 1);
    },

    async saveForm() {
      let data = {
        pageID: this.productForms.pageID,
        area: [this.productForms.area],
        delete_area: this.productForms.delete_area,
      };
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(form) {
      switch (form.type) {
        case 4:
          form.menu_dialog = true;
          break;
      }
    },
    modalClose(param) {
      let i = param.position;
      switch (param.type) {
        case 4:
          this.productForms.area[i].text = param.text;
          this.productForms.area[i].to = param.to;
          this.productForms.area[i].role = param.role;
          this.productForms.area[i].menu_dialog = false;
          this.productForms.area[i].color = param.color;
          break;
      }
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.type = value.Type;
        tmp.text = value.Label;
        tmp.role = value.Rule;
        tmp.to = value.Init;
        tmp.color = value.Value;
        tmp.menu_dialog = false;
        area.push(tmp);
      });
      return area;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
